import type { driver as driverFn } from 'driver.js';

let driverPromise: Promise<typeof driverFn> | null = null;

export const loadDriver = () => {
  if (!driverPromise) {
    import('driver.js/dist/driver.css');
    driverPromise = import('driver.js').then((mod) => mod.driver);
  }
  return driverPromise;
};
